import axios from 'axios';

export const getMyProfile = () => {
    return axios.get('/api/services/app/accountManagement/GetMyProfile');
};

export const updateMyProfile = (input) => {
    return axios.post('/api/services/app/accountManagement/UpdateMyProfile', input);
};